import React, { Component } from "react";
import { connect } from "react-redux";

// Components
import ErrorWrap from "../../utils/error-success/ErrorWrap";
import Button from "../../utils/Button";

// CSS
import "../../../css/forms/login.css";

// State
import { adminLogin, clearErrors } from "../../../store/actions/user";

// Utils
import { handleKeyPress, handleInputChange } from "../../../utils/forms/inputHandling";

class AdminLoginForm extends Component {
	constructor(props) {
		super(props);
		this.state = {
			data: {
				username: "",
				password: ""
			}
		};

		this.componentCleanup = this.componentCleanup.bind(this);
	}

	// ===================================
	//  LIFE CYCLE
	// ===================================
	componentDidMount() {
		window.addEventListener("beforeunload", this.componentCleanup);
	}

	componentCleanup() {
		this.props.clearErrors();
		window.removeEventListener("beforeunload", this.componentCleanup);
	}

	componentWillUnmount() {
		this.componentCleanup();
	}

	// ===================================
	//  SUBMIT
	// ===================================
	handleSubmit = () => {
		this.props.adminLogin(this.state.data.username, this.state.data.password);
	};

	// ===================================
	//  RENDER
	// ===================================
	render() {
		const { isLoading } = this.props;

		return (
			<div className="centered-form">
				<div className="form-title">Administrator Login</div>
				<div className="form-content">
					<div className="centered-form-field">
						<label htmlFor="username">Username:</label>

						{this.props.errors.username && (
							<ErrorWrap animate={1}>{this.props.errors.username}</ErrorWrap>
						)}
						<input
							type="text"
							name="username"
							id="username"
							disabled={isLoading}
							value={this.state.data.username}
							placeholder="username"
							onKeyPress={e => handleKeyPress(e, this.handleSubmit)}
							onChange={e => this.setState(handleInputChange(e, this.state))}
						/>
					</div>

					<div className="centered-form-field">
						<label htmlFor="password">Password:</label>

						{this.props.errors.password && (
							<ErrorWrap animate={1}>{this.props.errors.password}</ErrorWrap>
						)}
						<input
							type="password"
							name="password"
							id="password"
							disabled={isLoading}
							value={this.state.data.password}
							placeholder="password"
							onKeyPress={e => handleKeyPress(e, this.handleSubmit)}
							onChange={e => this.setState(handleInputChange(e, this.state))}
						/>
					</div>

					<div className="btn_container">
						{this.props.errors.general && (
							<ErrorWrap animate={1}>{this.props.errors.general}</ErrorWrap>
						)}
						<Button text={"Log In"} clickHandler={this.handleSubmit} {...this.props} />
					</div>
				</div>
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		errors: state.user.errors,
		isLoading: state.user.isLoading
	};
};

export default connect(
	mapStateToProps,
	{ adminLogin, clearErrors }
)(AdminLoginForm);



// WEBPACK FOOTER //
// ./src/components/admin/login/AdminLoginForm.js